// BuildOverview/BuildOverviewFetcher.js
// Singleton — does exactly 1 thing: raw I/O via BuildStatusService.
import buildStatusService from '../../../services/BuildStatusService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'BuildOverviewFetcher';

class BuildOverviewFetcher extends CoreBase {
    _name = _name;

    /**
     * @returns {Promise<object[]|null>} build status items, null when the request failed
     */
    fetch = async () => {
        try {
            const response = await buildStatusService.getBuildStatuses();
            const ok = response?.status >= 200 && response?.status < 300;
            const items = response?.data?.items;
            if (ok && Array.isArray(items)) return items;

            // agent returns null after its 401 retries, so the status is lost there
            const reason = response?.status ? `HTTP ${response.status}` : 'no HTTP response — 401 after token retries, network error, CORS or unknown KrakenD route';
            this.logError('fetch', `no build statuses — ${reason}`);
            return null;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };

    /**
     * @param {string[]} names - job names to start
     * @returns {Promise<boolean>} true when the gateway accepted the request
     */
    postJobs = async (names) => {
        try {
            const response = await buildStatusService.postBuildJobs(names);
            const ok = response?.status >= 200 && response?.status < 300;
            if (!ok) this.logError('postJobs', `start failed for ${names.join(', ')} — HTTP ${response?.status ?? 'none'}`);
            return ok;
        } catch (error) {
            this.logError('postJobs', error.message);
            return false;
        }
    };
}

const buildOverviewFetcher = new BuildOverviewFetcher();
export default buildOverviewFetcher;
